/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const StartOngoingIncidentRecord = zod.object({
  "id": zod.string().uuid()
});

export type StartOngoingIncidentRecord = zod.input<typeof StartOngoingIncidentRecord>;
export type StartOngoingIncidentRecordOutput = zod.output<typeof StartOngoingIncidentRecord>;
